import AppPermission from '@/api/AppPermission'

export default {
  namespaced: true,

  state: {
    permissionList: [],
  },

  mutations: {
    setPermissions (state, data = []) {
      state.permissionList = data
    },
  },

  actions: {
    async getAppPermissionList ({ commit }) {
      var result

      // check this api is still loading or not
      if (this.state.app.loadinglist.indexOf('getAppPermissionList') >= 0) return

      try {
        // start loading
        this.dispatch('Loading', true)
        // clear error
        this.dispatch('Error', null)
        // add loadinglist
        this.dispatch('addLoadinglist', 'getAppPermissionList')

        const response = await AppPermission.getList()

        // stop loading
        this.dispatch('Loading', false)
        // remove loadinglist
        this.dispatch('removeLoadinglist', 'getAppPermissionList')

        result = response.data

        if (result.success) {
          commit('setPermissions', result.data)
        } else {
          this.dispatch('Error', typeof result.error === 'string' ? result.error : result.status_message)
        }
      } catch (e) {
        this.dispatch('Error', e)
      }
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/AppPermission.js